export default __webpack_public_path__ + "static/media/niger.a551dba1.png";